import { IController } from 'angular';

export class DisplayController implements IController {
  /* tslint:enable */

  /* @ngInject */
  constructor(private $scope: ng.IScope, private $rootScope: ng.IRootScopeService, private mappings) {
    this.$scope.detailsVisible = this.$scope.detailsVisible || (this.isComplexType() && this.$scope.isEditing);
  }
  /* tslint:disable */
  $onInit = () => {};

  public showButtonGroup() {
    return this.isComplexType() && this.$scope.condition.conditions;
  }

  public showDisplayName() {
    const isEditing = this.$scope.isEditing;

    return !this.isComplexType() || !isEditing;
  }

  public showGroupHeader() {
    const detailsVisible = this.$scope.detailsVisible;
    let isEditing = this.$scope.isEditing;
    return this.isComplexType() && (detailsVisible || isEditing);
  }

  public removeDisplayCondition(conditions, condition) {
    this.removeDisplayConditionRecursive(conditions, condition);
    if (this.$scope.isEditing) {
      this.$rootScope.$broadcast('removeCondition');
    }
  }

  public removeDisplayConditionRecursive(conditionList, condition) {
    let index = conditionList.indexOf(condition);
    if (index !== -1) {
      conditionList.splice(index, 1);
      return true;
    }
    return conditionList.some((c) => {
      if (!c.conditions) {
        return false;
      }
      return this.removeDisplayConditionRecursive(c.conditions, condition);
    });
  }

  public editCondition(conditionList, condition) {
    let isEditing = this.$scope.isEditing;
    conditionList.forEach((c) => (c.$$editing = false));
    condition.$$editing = true;
    this.$rootScope.$broadcast('editCondition', condition, isEditing, conditionList);
  }

  private isComplexType(): boolean {
    let conditionType = this.$scope.condition['@type'];
    return conditionType === 'AndCondition' || conditionType === 'OrCondition';
  }
}
